module.exports = __webpack_public_path__ + "../resources/img/ic_no_result_search.c56828ac.svg";